import Button from '@/common/components/base/button/Button';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput';
import FreeZonePlateInput from '@/common/components/base/input/plate/freeZonePlateInput/FreeZonePlateInput';
import VehiclePlateInput from '@/common/components/base/input/plate/vehiclePlateInput/VehiclePlateInput';
import {
  PUBLIC_REQUIRED_RULE,
  requiredText,
} from '@/common/utils/rules/publicRules';
import { Controller, FormProvider } from 'react-hook-form';
import { Flex } from 'styled-system/jsx';
import useBodyPartOneHook from '@/modules/adjusterReportModules/Insurer-information/components/vehicleInformation/hooks/useBodyPartOneHook';
import CircularLoading from '@/common/components/base/Loading/CircularLoading';
import ImagesFabMainModal from '@/modules/adjusterReportModules/adjusterReport/components/imagesFab/ImagesFabMainModal';
import { VehiclePlateEmptyRules } from '@/common/components/base/input/plate/vehiclePlateInput/vehiclePlateInput.rules';
import { FreePlateEmptyRules } from '@/common/components/base/input/plate/freeZonePlateInput/freeZonePlateInput.rules';

const BodyPartOne = () => {
  const {
    VehiclePlateDesignWatch,
    data,
    methods,
    observerRefCallback,
    setName,
    submitHandler,
    patchPending,
    VehiclePlateTypeWatch,
    VehicleTypeWatch,
  } = useBodyPartOneHook();
  return (
    <>
      <FormProvider {...methods}>
        <Flex direction="column" gap={1} mb={24}>
          <ModalInput
            name="vehicle_type"
            placeholder="نوع وسیله‌نقلیه"
            label="نوع وسیله‌نقلیه"
            title="نوع وسیله‌نقلیه"
            disabled
            options={data?.vehicleTypes ?? []}
            rules={{ required: { message: requiredText, value: true } }}
          />
          <ModalInput
            name="vehicle_model"
            placeholder="انتخاب کنید"
            label="سیستم و تیپ"
            title="سیستم و تیپ"
            options={data?.vehicleSystems ?? []}
            disabled={VehicleTypeWatch === null}
            loading={data?.isVehicleSystemsPending}
            infiniteScrollRef={observerRefCallback}
            searchOptions={{
              onChange: (e) => {
                setName(e);
              },
              placeholder: 'جستجو کنید',
            }}
            rules={{ required: { message: requiredText, value: true } }}
          />
          <ModalInput
            name="vehicle_use"
            placeholder="انتخاب کنید"
            label="مورد استفاده"
            disabled={VehicleTypeWatch === null}
            title="مورد استفاده"
            options={data?.vehicleUses ?? []}
            rules={{ required: { message: requiredText, value: true } }}
          />
          <ModalInput
            name="vehicle_plate_type"
            placeholder="انتخاب کنید"
            label="نوع پلاک"
            disabled={VehicleTypeWatch === null}
            title="نوع پلاک"
            options={data?.plateTypes ?? []}
            rules={{ required: { message: requiredText, value: true } }}
          />

          <ModalInput
            name="vehicle_plate_design"
            label="طرح پلاک"
            title="طرح پلاک"
            placeholder="انتخاب کنید"
            disabled={VehicleTypeWatch === null}
            options={data?.plateDesigns ?? []}
            rules={{ required: { message: requiredText, value: true } }}
            onChange={() => {
              methods.setValue(
                'vehicle_plate.plate.vehicle_plate_bottom',
                undefined,
              );
              methods.setValue(
                'vehicle_plate.plate.vehicle_plate_top',
                undefined,
              );
            }}
          />
          <ModalInput
            name="vehicle_plate_sample"
            placeholder="انتخاب کنید"
            label="نمونه پلاک"
            disabled={
              VehicleTypeWatch === null ||
              VehiclePlateTypeWatch === null ||
              VehiclePlateDesignWatch === null
            }
            title="نمونه پلاک"
            options={data?.plateSamples ?? []}
            rules={
              data?.plateSamples?.length ? PUBLIC_REQUIRED_RULE : undefined
            }
            optionalLabel={!data?.plateSamples?.length}
          />
          {(VehiclePlateDesignWatch?.value === 'country' ||
            !VehiclePlateDesignWatch?.value) &&
          VehicleTypeWatch?.label !== 'موتورسیکلت' ? (
            <Controller
              name="vehicle_plate"
              rules={{
                validate: VehiclePlateEmptyRules,
              }}
              render={({ field, fieldState }) => {
                return (
                  <VehiclePlateInput
                    onChange={(v) => {
                      field.onChange(v);
                      if (methods.formState.touchedFields.vehicle_plate) {
                        methods.trigger('vehicle_plate');
                      }
                      v.plateString && methods.setValue('vehicle_plate', v);
                    }}
                    key={VehiclePlateDesignWatch?.value}
                    value={field.value}
                    requiredError={fieldState.error?.message}
                  />
                );
              }}
            />
          ) : (
            <Controller
              name="vehicle_plate"
              rules={{
                validate: (value) =>
                  FreePlateEmptyRules(
                    value,
                    VehicleTypeWatch?.label === 'موتورسیکلت' &&
                      VehiclePlateDesignWatch?.value === 'free_zone',
                  ),
              }}
              render={({ field, fieldState }) => {
                return (
                  <FreeZonePlateInput
                    onChange={(v) => {
                      field.onChange(v);
                      if (methods.formState.touchedFields.vehicle_plate) {
                        methods.trigger('vehicle_plate');
                      }
                      v.plateString && methods?.setValue('vehicle_plate', v);
                    }}
                    value={methods.getValues('vehicle_plate')}
                    requiredError={fieldState.error?.message}
                    vehicle_plate_design={
                      VehiclePlateDesignWatch?.value ?? 'country'
                    }
                    vehicle_type_id={VehicleTypeWatch?.value ?? 1}
                    key={VehiclePlateDesignWatch?.value}
                  />
                );
              }}
            />
          )}
          <Button
            onClick={methods?.handleSubmit(submitHandler)}
            width="100%"
            marginTop="32px"
            type="button"
            disabled={patchPending || !methods?.formState?.isValid}
          >
            {patchPending ? (
              <CircularLoading color="colors.purple-1" />
            ) : (
              'ثبت و ادامه'
            )}
          </Button>
        </Flex>
      </FormProvider>
      <ImagesFabMainModal state="body" />
    </>
  );
};
export default BodyPartOne;
